import {gql} from '@apollo/client';

export const QUERY_USER = gql`
  query User {
    user {
      id
      username
      role
      fullname
      phone
      avatar {
        id
        path
      }
      client {
        id
        newCount
        talkingId
        currentLevel
        isRepeat
        friendsCount
        activeTill
        currentStart
        balance
        mode
        skype
        zoom
        lastLetter {
          id
          isAdmin
        }
        city {
          id
          name
        }
        mentorings {
          id
          rating
          group {
            id
            name
            startedAt
            isClosed
            teacher {
              id
              user {
                id
                fullname
              }
            }
          }
        }
      }
    }
  }
`;

export const FRAGMENT_CLIENT_LIST = gql`
  fragment ClientList on ClientType {
    id
    talkingId
    friendsCount
    currentStart
    mode
    skype
    zoom
    city {
      id
      name
    }
    user {
      id
      username
      fullname
      phone
      avatar {
        id
        path
      }
    }
  }
`;

export const QUERY_CLIENT_LIKES_LIST = gql`
  query ClientLikesList($days: Int) {
    clientLikesList(days: $days) {
      ...ClientList
      likesCount
    }
  }
  ${FRAGMENT_CLIENT_LIST}
`;

export const MUTATION_CLIENT_UPDATE = gql`
  mutation ClientUpdate($input: ClientUpdateInput!) {
    clientUpdate(input: $input) {
      obj {
        id
        mode
        currentStart
        city {
          id
          name
        }
      }
    }
  }
`;
